export default function Spinner() {
  return (
    <div className="spinner-border text-100-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}
